import { observable, action, computed } from 'mobx';
import { SdAnalytics } from 'api';
import { sortByDesc } from 'utils/sorter';
import { months, monthsMap } from 'utils/constants';
import { ru } from 'locale';

class DebtorStore {
  @observable.ref report = {};

  @observable fetchState;

  anketId;

  debtorId;

  @computed
  get debtor() {
    return this.report.debtor;
  }

  @computed
  get sortedYears() {
    return this.report.years.sort(sortByDesc);
  }

  getSortedMonths = () => {
    return [...months].reverse();
  };

  getCellContent = ({ columnId, year, headerRow, headerRowIndex }) => {
    if (columnId === 'years') {
      if (headerRowIndex === 0) {
        return `${ru.total}\n${year}`;
      }

      return monthsMap[headerRow];
    }

    const month = headerRow.toLowerCase();

    if (headerRowIndex === 0) {
      return this.report[columnId][year][month];
    }

    return this.report[columnId][year].items[month];
  };

  createTableData = columns => {
    const { grandTotal } = this.report;
    const sortedMonths = this.getSortedMonths();
    const grandTotalRow = { years: ru.forAllYears, ...grandTotal };
    const headerRows = ['total', ...sortedMonths];
    const data = this.sortedYears.reduce((acc, year) => {
      const rows = headerRows.reduce((rowsAcc, headerRow, headerRowIndex) => {
        const row = columns.reduce((rowAcc, { dataKey }) => {
          const cell = this.getCellContent({
            columnId: dataKey,
            year,
            headerRow,
            headerRowIndex,
          });

          return { ...rowAcc, [dataKey]: cell };
        }, []);

        return [...rowsAcc, row];
      }, []);

      return [...acc, ...rows];
    }, []);

    return [grandTotalRow, ...data];
  };

  @action.bound
  async getReport(anketId, debtorId) {
    if (this.anketId === anketId && this.debtorId === debtorId) {
      return;
    }

    this.fetchState = 'pending';

    try {
      const response = await SdAnalytics.getReport(anketId, debtorId);
      this.report = response.data;
      this.fetchState = 'fulfilled';
      this.anketId = anketId;
      this.debtorId = debtorId;
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }
}

const debtorStore = new DebtorStore();

export default debtorStore;
